export const LETTERS_LATIN_CHARACTERS_AND_NUMBERS = /[^A-Za-z0-9\sÀ-ÿ\u00f1\u00d1\u00b4\s./#-]+$/g;
export const LETTERS_DOT_AND_SPACE = /[^A-Za-z\sÀ-ÿ\u00f1\u00d1\u00b4\s.]+$/g;
export const WITHOUT_LAST_SPACES = /\s{2,}/;
export const ONLY_NUMBERS = /[^0-9]/g;

export const lettersAndLatinCharactersMask = {
  apply: (value, withoutLastSpaces = true) => {
    const masked = value.replace(LETTERS_LATIN_CHARACTERS_AND_NUMBERS, '');
    return withoutLastSpaces ? removeLastSpaces(masked) : masked;
  },
  match: (value) => LETTERS_LATIN_CHARACTERS_AND_NUMBERS.test(value)
};

export const lettersDotAndSpaceMask = {
  apply: (value) => value.replace(LETTERS_DOT_AND_SPACE, ''),
  match: (value) => LETTERS_DOT_AND_SPACE.test(value)
};

export const numbersMask = {
  apply: (value) => value.replace(ONLY_NUMBERS, ''),
  match: (value) => ONLY_NUMBERS.test(value)
};

export const removeLastSpaces = (value) =>
  value.replace(WITHOUT_LAST_SPACES, ' ');

export const cleanInvalidWords = (value) => value.replace('null', '').replace('undefined', '');
